import { TASK_LIST } from '../../actions/types';
import { CURRENT_TAX_YEAR } from '../../global/Environment';
import { TASK_LIST_TABS } from '../../constants';

const initialState = {
  errorMessage: '',
  taxYear: CURRENT_TAX_YEAR,
  showAllReturns: false,
  order: null,
  bulkEditMode: null,
  bulkEditTasks: [],
  filters: {},
  currentTab: TASK_LIST_TABS.ALL_TASKS,
  pageNumber: 1
};

export default function taskListReducer(state = initialState, action) {
  switch (action.type) {
    case TASK_LIST.SET_ERROR_MESSAGE:
      return {
        ...state,
        errorMessage: action.payload
      };
    case TASK_LIST.SET_YEAR:
      return {
        ...state,
        taxYear: action.payload
      };
    case TASK_LIST.SET_SHOW_ALL:
      return {
        ...state,
        showAllReturns: action.payload
      };
    case TASK_LIST.SET_ORDER:
      return {
        ...state,
        order: action.payload
      };
    case TASK_LIST.SET_BULK_EDIT_MODE:
      return {
        ...state,
        bulkEditMode: action.payload
      };
    case TASK_LIST.SET_BULK_EDIT_TASKS:
      return {
        ...state,
        bulkEditTasks: action.payload
      };
    case TASK_LIST.SET_FILTERS:
      return {
        ...state,
        filters: action.payload
      };
    case TASK_LIST.SET_CURRENT_TAB:
      return {
        ...state,
        currentTab: action.payload
      };
    case TASK_LIST.SET_PAGE_NUMBER:
      return {
        ...state,
        pageNumber: action.payload
      };
    default:
      return state;
  }
}
